export const INFORM_API            = "INFORM_API"
export const INFORM_DELETE_API     = "INFORM_DELETE_API"
export const INFORM_SET            = "INFORM_SET"
export const INFORM_DELETE         = "INFORM_DELETE"

